var freshConfig = {
    api_key : "QfR3Kgc6omH5ZNytYI8p",
    password : "x",
    headers : { 'Content-Type' : 'application/json' },
    endpoint : 'https://tpoconcierge.freshdesk.com/api/v2/',
}

export default freshConfig;